import { combineReducers } from 'redux';
import { reducer as modal } from 'redux-modal';
// import { ignoreActions } from 'redux-ignore';

import { auth } from './auth';
import { nav } from './nav';
/* GENERATOR_INJECT_IMPORT_REDUCER */
export default combineReducers({
  modal,
  auth,
  nav,
});
